import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./Style/Common.css";
import "./Style/Header.css";
import "./Style/Loggedout.css";

const LoggedOut: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const target = searchParams.get("Target") || "";
  const schoolCode = searchParams.get("SchoolCode") || "";

  const handleLogBackIn = () => {
    // Clear session/local storage
    localStorage.clear();
    sessionStorage.clear();

    if (!schoolCode) {
      navigate("/");
      return;
    }

    if (target === "FamilyLogin") {
      navigate(`/login/family-login?C=${schoolCode}`);
    } else if (target === "SchoolLogin") {
      navigate(`/login/school-login?C=${schoolCode}`);
    } else {
      navigate("/");
    }
  };

  return (
    <div id="form1">
      <div id="logged_out">
        <div id="logged_out_image"></div>
        <p>
          <span className=" title_textT" style={{ marginTop: "40px" }}>See you soon</span>
          <span id="ar_text" className="state_text">
            You have been logged out.
          </span>
        </p>

        <div
          id="lo_close_btn"
          className="general_btn two_btn"
          onClick={handleLogBackIn}
        >
          <button type="button" className="linkbtnLogbackInT">
            <span id="spnLogbackIn">Log back In</span>
          </button>
        </div>
      </div>
      <input type="hidden" id="hidSchoolCode" value={schoolCode} readOnly />
    </div>
  );
};

export default LoggedOut;